// extracted by mini-css-extract-plugin
export default {"list":"ListManager_list__BOM59","item":"ListManager_item__tBCyt","icon":"ListManager_icon__7r61I","input":"ListManager_input__PCrUt"};